import TomSelect from "tom-select"

const legacySelector = "select.tom-select:not([data-controller~=\"tom-select\"])"

const defaultPlugins = (element) => {
  if (element.multiple) { return ["remove_button"] }

  const canBeCleared = Array.from(element.options).some((option) => option.value === "")
  return canBeCleared ? ["clear_button"] : []
}

const noResultsRenderer = (text) => () => {
  const element = document.createElement("div")
  element.className = "no-results"
  element.textContent = text
  return element
}

const toggleCustomField = (element, value) => {
  const selector = element.dataset.tomSelectShowCustomField
  const trigger = element.dataset.tomSelectShowCustomFieldTrigger
  if (!selector || !trigger) { return }

  const target = document.querySelector(selector)
  const values = Array.isArray(value) ? value : [value]
  target?.classList.toggle("is--hidden", !values.includes(trigger))
}

export const initializeTomSelect = (element, { noResultsText, prompt, ...options } = {}) => {
  if (element.tomselect) { return element.tomselect }

  const onChange = options.onChange
  const render = { ...options.render }
  if (noResultsText) { render.no_results = noResultsRenderer(noResultsText) }

  const configuration = {
    maxOptions: null,
    plugins: defaultPlugins(element),
    ...options,
    render,
    onChange(value) {
      toggleCustomField(element, value)
      onChange?.call(this, value)
    },
  }
  const placeholder = prompt ?? options.placeholder ?? element.dataset.prompt
  if (placeholder !== undefined) { configuration.placeholder = placeholder }

  const select = new TomSelect(element, configuration)
  toggleCustomField(element, element.multiple ? select.items : select.getValue())
  return select
}

export const initializeTomSelects = (root = document) => {
  const elements = root.matches?.(legacySelector)
    ? [root]
    : Array.from(root.querySelectorAll(legacySelector))

  return elements.map((element) => initializeTomSelect(element))
}

export const startTomSelects = () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeTomSelects(), { once: true })
  } else {
    initializeTomSelects()
  }
}
